module.exports = __webpack_public_path__ + "img/٢٠٢٠٠٧٢٥_١٤٠٣٢١.a53b57b4.jpg";